import React, { useState, useRef } from "react";

const LayoutTab = ({handleLayoutChange,selectedLayout,updateInstagramFeedTabData,instagramFeedTabData}) => {
    const [activeSettingTab, setActiveSettingTabsElements] = useState("main");
    const [activeColumnsModeType, setActiveColumnsModeType] = useState(instagramFeedTabData.columns_mode_type);
    const [selectedLayoutTabColumns, setSelectedLayoutTabColumns] = useState(instagramFeedTabData.layout_columns);
    const [showLayoutTabColumnsDropdown, setShowLayoutTabColumnsDropdown] = useState(false);
    const [selectedLayoutTabRows, setSelectedLayoutTabRows] = useState(instagramFeedTabData.layout_rows);
    const [showLayoutTabRowsDropdown, setShowLayoutTabRowsDropdown] = useState(false);
    const [selectedLayoutTabSpacing, setSelectedLayoutTabSpacing] = useState(instagramFeedTabData.layout_item_spacing);
    const [showLayoutTabSpacingDropdown, setShowLayoutTabSpacingDropdown] = useState(false);
    const [isHeaderShow, setIsHeaderShow] = useState(Number(instagramFeedTabData.header_is_show_header));
    const [showHeaderProfilePicture, setIsHeaderProfilePicture] = useState(Number(instagramFeedTabData.header_profile_picture));
    const [showHeaderFullName, setIsHeaderFullName] = useState(Number(instagramFeedTabData.header_full_name));
    const [showHeaderUsername, setIsHeaderUsername] = useState(Number(instagramFeedTabData.header_username));
    const [showHeaderVerifiedBadge, setIsHeaderVerifiedBadge] = useState(Number(instagramFeedTabData.header_verified_badge));
    const [showHeaderPostsCount, setIsHeaderPostsCount] = useState(Number(instagramFeedTabData.header_posts_count));
    const [showHeaderFollowersCount, setIsHeaderFollowersCount] = useState(Number(instagramFeedTabData.header_followers_count));
    const [showHeaderFollowingCount, setIsHeaderFollowingCount] = useState(Number(instagramFeedTabData.header_following_count));
    const [showHeaderFollowButton, setIsHeaderFollowButton] = useState(Number(instagramFeedTabData.header_follow_button));

    //Custom Width
    const [isOpen, setIsOpen] = useState(false);
    const [width, setWidth] = useState(instagramFeedTabData.layout_custom_width || 1280);
    const [isFullWidth, setIsFullWidth] = useState(Number(instagramFeedTabData.layout_is_full_width));
    const popupRef = useRef(null);


   
    const {
        feed_title,
    } = instagramFeedTabData || {};

    //Handle Columns Mode Type change
    const handleActiveColumnsModeTypeChange = (event) => {
        setActiveColumnsModeType(event.target.value);
        updateInstagramFeedTabData("columns_mode_type", event.target.value);
    };

    //Handle Columns Dropdown Change
    const toggleLayoutTabColumnsDropdown = () => {
        setShowLayoutTabColumnsDropdown(!showLayoutTabColumnsDropdown);
    };
    //Handle Columns Change
    const handleLayoutTabColumnSelect = (row) => {
        setSelectedLayoutTabColumns(row);
        setShowLayoutTabColumnsDropdown(false);
        updateInstagramFeedTabData("layout_columns", row); 
    };

    //Handle Rows Dropdown Change
    const toggleLayoutTabRowsDropdown = () => {
        setShowLayoutTabRowsDropdown(!showLayoutTabRowsDropdown);
    };
    //Handle Rows Change
    const handleLayoutTabRowSelect = (row) => {
        setSelectedLayoutTabRows(row);
        setShowLayoutTabRowsDropdown(false);
        updateInstagramFeedTabData("layout_rows", row); 
    };

    //Handle Spacing Dropdown Change
    const toggleLayoutTabSpacingDropdown = () => {
        setShowLayoutTabSpacingDropdown(!showLayoutTabSpacingDropdown);
    };
    //Handle Spacing Change
    const handleLayoutTabSpacingSelect = (spacing) => {
        setSelectedLayoutTabSpacing(spacing);
        updateInstagramFeedTabData("layout_item_spacing", spacing); 
        setShowLayoutTabSpacingDropdown(false); 
    };

    //Handle Show Header toggle
    const handleIsHeaderShowToggle = (e) => {
        const checked = e.target.checked;
        setIsHeaderShow(checked);
        updateInstagramFeedTabData('header_is_show_header', checked);
    };

    // Handlers Header Profile Picture
    const handleHeaderProfilePictureChange = (e) => {
        const checked = e.target.checked;
        setIsHeaderProfilePicture(checked);
        updateInstagramFeedTabData("header_profile_picture", checked); 
    };

    // Handlers Header Full Name
    const handleHeaderFullNameChange = (e) => {
        const checked = e.target.checked;
        setIsHeaderFullName(checked);
        updateInstagramFeedTabData("header_full_name", checked); 
    };

    // Handlers Header Username
    const handleHeaderUsernameChange = (e) => {
        const checked = e.target.checked;
        setIsHeaderUsername(checked);
        updateInstagramFeedTabData("header_username", checked); 
    };

    // Handlers Header VerifiedBadge
    const handleHeaderVerifiedBadgeChange = (e) => {
        const checked = e.target.checked;
        setIsHeaderVerifiedBadge(checked);
        updateInstagramFeedTabData("header_verified_badge", checked); 
    };

    // Handlers Header Posts Count
    const handleHeaderPostsCountChange = (e) => {
        const checked = e.target.checked;
        setIsHeaderPostsCount(checked);
        updateInstagramFeedTabData("header_posts_count", checked); 
    };

    // Handlers Header Followers Count
    const handleHeaderFollowersCountChange = (e) => {
        const checked = e.target.checked;
        setIsHeaderFollowersCount(checked);
        updateInstagramFeedTabData("header_followers_count", checked); 
    };

    // Handlers Header Following Count
    const handleHeaderFollowingCountChange = (e) => {
        const checked = e.target.checked;
        setIsHeaderFollowingCount(checked);
        updateInstagramFeedTabData("header_following_count", checked); 
    };

    // Handlers Header Follow Button
    const handleHeaderFollowButtonChange = (e) => {
        const checked = e.target.checked;
        setIsHeaderFollowButton(checked);
        updateInstagramFeedTabData("header_follow_button", checked); 
    };


    //Toggle Popup
    const togglePopup = () => setIsOpen(!isOpen);
    //Handle Width Chnage
    const handleWidthChange = (e) => {
        const newWidth = parseInt(e.target.value, 10);
        setWidth(newWidth);
        updateInstagramFeedTabData('layout_custom_width', newWidth);
    };
    //Handle full width toggle
    const handleFullWidthToggle = () => {
        const newState = !isFullWidth;
        setIsFullWidth(newState);
        updateInstagramFeedTabData('layout_is_full_width', newState);
        if (!newState) {
            updateInstagramFeedTabData('layout_custom_width', width);
        }
    };

    return (
        <div className="side-baar-inner-setting">
            {activeSettingTab === "main" && (
                <>
                    <span>Layout</span>
                    <div className="side-baar-box-header">
                        <div className="layout-box-all">
                            <div className="card h-100">
                                <div className="label-box-flex">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="layout_tab_type" value="slider_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'slider_layout'}/>
                                        <div className="card card-body">
                                            <div className="content_head">
                                                <svg className="gry-image" width="auto" height="60"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M22 21a1 1 0 0 1 1 1v21a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V22a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v21a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V22a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v21a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V22a1 1 0 0 1 1-1h12Zm4.302 7.307a1.016 1.016 0 0 1 1.455 0l2.64 2.71a2.126 2.126 0 0 1 0 2.967l-2.64 2.709c-.402.41-1.053.41-1.455 0a1.063 1.063 0 0 1 0-1.484l1.911-1.967a1.063 1.063 0 0 0 0-1.484l-1.911-1.967a1.063 1.063 0 0 1 0-1.484Zm-54.604 0c.403.41.403 1.074 0 1.484l-1.911 1.967a1.063 1.063 0 0 0 0 1.484l1.911 1.967c.403.41.403 1.074 0 1.484-.402.41-1.053.41-1.455 0l-2.64-2.71a2.127 2.127 0 0 1 0-2.967l2.64-2.709a1.016 1.016 0 0 1 1.455 0Z" fill="#7B7D8F"></path></svg>

                                                <svg className="blue-image" width="auto" height="60" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M22 21a1 1 0 0 1 1 1v21a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V22a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v21a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V22a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v21a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V22a1 1 0 0 1 1-1h12Zm4.302 7.307a1.016 1.016 0 0 1 1.455 0l2.64 2.71a2.126 2.126 0 0 1 0 2.967l-2.64 2.709c-.402.41-1.053.41-1.455 0a1.063 1.063 0 0 1 0-1.484l1.911-1.967a1.063 1.063 0 0 0 0-1.484l-1.911-1.967a1.063 1.063 0 0 1 0-1.484Zm-54.604 0c.403.41.403 1.074 0 1.484l-1.911 1.967a1.063 1.063 0 0 0 0 1.484l1.911 1.967c.403.41.403 1.074 0 1.484-.402.41-1.053.41-1.455 0l-2.64-2.71a2.127 2.127 0 0 1 0-2.967l2.64-2.709a1.016 1.016 0 0 1 1.455 0Z" fill="#5A5AFF"></path></svg>
                                            </div>
                                            <div className="content_sub">Slider</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="layout_tab_type" value="grid_layout" className="card-input-element d-none" onChange={handleLayoutChange} checked={selectedLayout === 'grid_layout'} />
                                        <div className="card card-body">
                                            <div className="content_head">
                                                <svg className="gry-image" width="auto" height="60"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M22 42a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h12ZM22 25a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h12ZM22 8a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h12Z" clip-rule="evenodd" fill="#7B7D8F"></path></svg>

                                                <svg className="blue-image" width="auto" height="60" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M22 42a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V43a1 1 0 0 1 1-1h12ZM22 25a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V26a1 1 0 0 1 1-1h12ZM22 8a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h13Zm17 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H26a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h13Zm16 0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H43a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h12Z" clip-rule="evenodd" fill="#5A5AFF"></path></svg>
                                            </div>
                                            <div className="content_sub">Grid</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>      
                    <div className="customize-elements-list">
                        <ul>
                            <li><button onClick={() => setActiveSettingTabsElements("columns_and_rows")}>Columns and Rows <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveSettingTabsElements("header")}>Header <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                            <li><button onClick={() => setActiveSettingTabsElements("feed_title")}>Feed Title <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingTab === "columns_and_rows" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Columns and Rows</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Columns Mode</span>
                                <div className="left-cnater-right-button">
                                    <label className="card-radio-btn">
                                        <input type="radio" name="columns_mode_type" className="card-input-element d-none" value="auto" onChange={handleActiveColumnsModeTypeChange} checked={activeColumnsModeType === "auto"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Auto</div>
                                        </div>
                                    </label>
                                    <label className="card-radio-btn">
                                        <input type="radio" name="columns_mode_type" className="card-input-element d-none" value="manual" onChange={handleActiveColumnsModeTypeChange} checked={activeColumnsModeType === "manual"} />
                                        <div className="card card-body">
                                            <div className="content_sub">Manual</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            {activeColumnsModeType === "manual" && (
                                <div className="box-header-row">
                                    <span>Columns</span>
                                    <div className="dropdown-container">
                                        <em onClick={toggleLayoutTabColumnsDropdown}>{selectedLayoutTabColumns}</em>
                                        {showLayoutTabColumnsDropdown && (
                                            <ul className="dropdown-list">
                                                {[...Array(10).keys()].map((i) => {
                                                    const columnsValue = i + 1; 
                                                    return (
                                                        <li key={columnsValue} onClick={() => handleLayoutTabColumnSelect(columnsValue)}>
                                                            {columnsValue}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            )}
                            <div className="box-header-row">
                                <span>Rows</span>
                                <div className="dropdown-container">
                                    <em onClick={toggleLayoutTabRowsDropdown}>{selectedLayoutTabRows}</em>
                                    {showLayoutTabRowsDropdown && (
                                        <ul className="dropdown-list">
                                            {[...Array(5).keys()].map((i) => {
                                                const rowValue = i + 1; 
                                                return (
                                                    <li key={rowValue} onClick={() => handleLayoutTabRowSelect(rowValue)}>
                                                        {rowValue}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Gap</span>
                                <div className="dropdown-container">
                                    <em onClick={toggleLayoutTabSpacingDropdown}>{selectedLayoutTabSpacing}px</em>
                                </div>
                                {showLayoutTabSpacingDropdown && (
                                    <ul className="dropdown-list">
                                        {[0, 2, 5, 10, 20, 30, 40, 50].map((spacing) => (
                                            <li key={spacing} onClick={() => handleLayoutTabSpacingSelect(spacing)}>
                                                {spacing}px
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                            <div className="customize-width mt-0 position-relative">
                                <div className="box-header-row" onClick={togglePopup}>
                                    <span>Width</span>
                                    <em>{!isFullWidth ? (width === 'auto' ? 'Auto' : `${width}px`) : 'Full Width'}</em>
                                </div>

                                {isOpen && (
                                    <div ref={popupRef} className="width-custom-box width-custom-box-open w-100" style={{bottom: 'auto', top: '50px'}}>
                                        <div className="width-custom-inner px-2">
                                            <ul>
                                                <li className="d-flex justify-content-between align-items-center">
                                                    <h6 className="col w-auto m-0 text-start">Width</h6>
                                                    <button className="col w-auto text-end" onClick={() => setIsOpen(false)}>Done</button>
                                                </li>
                                                <li>
                                                    <span>Full Width</span>
                                                    <div className="form-group">
                                                        <input
                                                            type="checkbox"
                                                            id="layout_full_width_toggle"
                                                            className="chkbx-toggle"
                                                            checked={isFullWidth}
                                                            onChange={handleFullWidthToggle}
                                                        />
                                                        <label htmlFor="layout_full_width_toggle"></label>
                                                    </div>
                                                </li>
                                                {!isFullWidth && (
                                                    <li>
                                                        <span>Custom Width</span> <em>{width}px</em>
                                                        <div className="slider-container">
                                                            <input
                                                                type="range"
                                                                min="250"
                                                                max="1920"
                                                                value={width}
                                                                onChange={handleWidthChange}
                                                            />
                                                            <div className="value">{width}px</div>
                                                        </div>
                                                    </li>
                                                )}
                                            </ul>
                                            <i className="fa fa-sort-desc" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingTab === "header" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Header</span>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Show header</span>
                            <div className="form-group">
                                <input
                                    type="checkbox"
                                    id="header_show_header_toggle"
                                    className="chkbx-toggle"
                                    checked={isHeaderShow}
                                    onChange={handleIsHeaderShowToggle}
                                />
                                <label htmlFor="header_show_header_toggle"></label>
                            </div>
                        </div>
                    </div>

                    {/* Show Header Elements */}
                    {isHeaderShow && (
                    <>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Header Elements</span>
                            <ul>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="profilePicture" checked={showHeaderProfilePicture} onChange={handleHeaderProfilePictureChange} /> 
                                        <label for="profilePicture">Profile Picture</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="fullName" checked={showHeaderFullName} onChange={handleHeaderFullNameChange} /> 
                                        <label for="fullName">Full Name</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="Username" checked={showHeaderUsername} onChange={handleHeaderUsernameChange} /> 
                                        <label for="Username">Username</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="verifiedBadge" checked={showHeaderVerifiedBadge} onChange={handleHeaderVerifiedBadgeChange} /> 
                                        <label for="verifiedBadge">Verified Badge</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="postsCount" checked={showHeaderPostsCount} onChange={handleHeaderPostsCountChange} /> 
                                        <label for="postsCount">Posts Count</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="followersCount" checked={showHeaderFollowersCount} onChange={handleHeaderFollowersCountChange} /> 
                                        <label for="followersCount">Followers Count</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="followingCount" checked={showHeaderFollowingCount} onChange={handleHeaderFollowingCountChange} /> 
                                        <label for="followingCount">Following Count</label>
                                    </div>
                                </li>
                                <li>
                                    <div className="form-group">
                                        <input type="checkbox" id="followButton" checked={showHeaderFollowButton} onChange={handleHeaderFollowButtonChange} /> 
                                        <label for="followButton">Follow Button</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    </>
                    )}
                </>
            )}

            {activeSettingTab === "feed_title" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Feed Title</span>
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <h6>Title</h6>
                            <input type="text" value={feed_title || ""} placeholder="Feed Title" onChange={(e) => updateInstagramFeedTabData('feed_title', e.target.value)} className="title-text" />
                        </div>
                    </div>
                    <p>URLs, hashtags (with #) and Instagram usernames (with @) will be automatically displayed as clickable links.</p>
                </>
            )}
        </div>
    );
};

export default LayoutTab;